import { render } from "./EmbedFinancialSupports.vue?vue&type=template&id=f1a0d788"
import script from "./EmbedFinancialSupports.vue?vue&type=script&lang=js"
export * from "./EmbedFinancialSupports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__